import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="code" {...props} />;
}

export const meta = {
  id: 'CodeEditor',
  title: 'CodeEditor',
  category: 'Utils',
  // exposes: [
  //   {
  //     title: 'General',
  //     action: { module: 'CodeEditor', props: { /* */ } },
  //     desription: 'general-desc',
  //   },
  // ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `An editor to be used to work on scripts`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
